import React from 'react';
import PropTypes from 'prop-types';
import MaterialCheckbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const Checkbox = (props) => {
    return (
        <FormControlLabel label={props.label}
                          control={
                              <MaterialCheckbox color="secondary" size="small"
                                                checked={props.checked} onChange={props.onChange}
                              />
                          }
                          disabled={props.disabled}
        />
    );
};

Checkbox.propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
    disabled: false,
};

export default Checkbox;
